module.exports = __webpack_public_path__ + "static/img/exam_8.f64a1c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/exam_8.png
// module id = fog4
// module chunks = 1